import { jsx, jsxs } from "react/jsx-runtime";
import { components } from "react-select";
import { noOptionsMessageStyles, groupHeadingStyles, menuStyles, indicatorsContainerStyles, valueContainerStyles, placeholderStyles, optionStyles, dropdownIndicatorStyles, singleValueStyles, selectInputStyles, controlStyles } from "./styles.js";
import { Icon } from "@tameeni/icons";
import { cn } from "@tameeni/shared-logic";
const CustomOption = (props) => {
  const { children, isSelected } = props;
  return /* @__PURE__ */ jsx(components.Option, { ...props, isMulti: true, children: /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "w-4 h-4 border flex items-center justify-center me-2 rounded-xs",
          isSelected ? "border-green-500 bg-green-500" : "border-slate-400 bg-white"
        ),
        children: isSelected && /* @__PURE__ */ jsx(Icon, { className: "w-3 h-3 text-white", name: "Checked" })
      }
    ),
    children
  ] }) });
};
const CustomInput = (props) => {
  const { hasValue, isFocused, selectProps } = props;
  return /* @__PURE__ */ jsx(
    components.Input,
    {
      ...props,
      isHidden: false,
      className: cn(
        hasValue && !isFocused && "text-slate-500 text-b2 capitalize truncate"
      ),
      placeholder: hasValue && !isFocused && selectProps.placeholder
    }
  );
};
const getClassNames = (args) => {
  return {
    control: ({
      isDisabled,
      isMulti
    }) => cn(
      controlStyles.base,
      isDisabled && controlStyles.disabled,
      isMulti && controlStyles.multi,
      args.isInvalid && controlStyles.invalid,
      args.isMenuOpened && controlStyles.menuOpened
    ),
    placeholder: () => placeholderStyles,
    multiValue: () => "!hidden",
    input: () => cn(selectInputStyles.base, args.isSelected && selectInputStyles.selected),
    valueContainer: () => valueContainerStyles,
    singleValue: () => cn(singleValueStyles.base, args.isSelected && singleValueStyles.selected),
    indicatorsContainer: () => indicatorsContainerStyles,
    indicatorSeparator: () => "none",
    dropdownIndicator: ({ isDisabled }) => cn(
      dropdownIndicatorStyles.base,
      isDisabled && dropdownIndicatorStyles.disabled
    ),
    menu: () => menuStyles,
    groupHeading: () => groupHeadingStyles,
    option: ({ isSelected }) => cn(isSelected && optionStyles.selected, optionStyles.base),
    noOptionsMessage: () => noOptionsMessageStyles,
    clearIndicator: () => "!hidden"
  };
};
export {
  CustomInput,
  CustomOption,
  getClassNames
};
